<template>
  <div>
    <HeaderContent title="CheckOut Lists" />
    <ActionContent
      :cta="false"
      :filter-modal="false"
      ctaText="Add Check Out"
      @action="modal = !modal"
      @showFilter="modalFilter = !modalFilter"
      v-model:start-date="startDate"
      v-model:end-date="endDate"
      v-model:search="search"
      @search-query="handleSearch"
    />
    <CheckOutStatistics title="Check Out Statistics" :data="statistics" />
    <CheckOutForm :modal="modal" @update:modal="modal = $event" />
    <CheckOutFilter
      :modalFilter="modalFilter"
      @update:modalFilter="modalFilter = $event"
    />
    <ModalConfirm v-model="modalConfirm" handle-action="setCheckout">
      <template #text>Are you sure to checkout this guest ?</template>
    </ModalConfirm>
    <PaymentForm
      :modal="modalPayment"
      :uuid="reservationUuid"
      @update:modal="modalPayment = $event"
      @paid="getAll"
    />

    <CheckoutDetail
      title="Check-Out Info"
      :uuid="reservationUuid"
      :data="checkout"
      v-model="modalDetail"
      @update:modal="modalDetail = $event"
    >
    </CheckoutDetail>

    <CheckOutConfirm
      title="Check Out Confirmation"
      :uuid="reservationUuid"
      :data="checkout"
      :actionType="actionType"
      :modalConfirm="modalCheckOut"
      v-model="modalCheckOut"
      @confirmed="handleAction"
    >
      <template #body>
        <div class="guest-info text-start" id="printArea">
          
          <!--  Kop & logo (print)  -->
          <div class="print-only" style="text-align: center; margin: 0; padding: 0">
            <table
              class="w-full border-collapse"
              style="width: 100%; border-collapse: collapse"
            >
              <tbody style="padding: 0; margin: 0">
                <tr class="border-b border-transparent">
                  <td class="text-center" style="text-align: center">
                    <img
                      src="../../../public/img/hotel-deliriver.png"
                      alt="Deli River Hotel Logo"
                      style="width: 50px; height: auto"
                    />
                  </td>
                </tr>
                <tr
                  class="border-b border-transparent"
                  style="padding: 0px; margin: 0px"
                >
                  <td class="text-center">
                    <h3 class="text-center">Deli River Hotel</h3>
                    <p class="text-center">
                      Jl. Raya Namorambe No. 129, Medan, Indonesia
                    </p>
                    <p class="text-center">www.hotel-deliriver.com</p>
                    <p class="text-center">contact@hotel-deliriver.com</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>

          <h4 class="print-only text-align-center">CheckOut Receipt</h4>

          <div class="px-3 border-bottom">
            <p class="text-secondary fw-semibold mb-2">Guest Information</p>
            <table class="w-full text-left border-collapse">
              <tbody>
                <tr class="border-b border-transparent">
                  <td class="text-left">Res. Number</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.number ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Name</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.guest?.fullname ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Contact</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    0{{ checkout?.reservation?.guest?.phone ?? "-" }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Check In</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ dateFormatter(checkout?.check_in_date) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Check Out</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ dateFormatter(checkout?.check_out_date) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Stay Duration</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ countDays(checkout?.check_in_date, checkout?.check_out_date) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div>
            <p class="text-secondary fw-semibold billing-detail">Billing Detail</p>
            <table class="w-full text-left border-collapse table-billing">
              <tbody>
                <tr class="border-b border-transparent">
                  <td class="text-left">Room Type</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      checkout?.reservation?.room?.room_category?.name ?? "-"
                    }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Room Number</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.room?.code ?? "-" }}
                  </td>
                </tr>
                <!-- //comment dulu karna pencocokan harga kamar normal & highseason -->
                <!-- <tr class="border-b border-transparent">
                  <td class="text-left">Room Rate</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      formatIDR(
                        checkout?.reservation?.room?.room_category
                          ?.low_season_price ?? 0
                      )
                    }}
                  </td>
                </tr> -->

                <!-- Extra Charge -->
                <tr class="border-b border-transparent align-top">
                  <td class="text-left">Extra Charge</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    <div v-if="!checkout?.reservation?.extracharge?.length">
                      -
                    </div>
                    <div
                      v-else
                      v-for="(item, index) in checkout?.reservation
                        ?.extracharge"
                      :key="index"
                    >
                      {{ item.extra_charge?.name }} (Qty: {{ item.quantity }},
                      {{ formatIDR(item?.price ?? 0) }})
                    </div>
                  </td>
                </tr>

                <!-- Payments -->
                <tr class="border-b border-transparent align-top">
                  <td class="text-left">Payment</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    <div v-if="!checkout?.reservation?.payment?.length">-</div>
                    <div
                      v-else
                      v-for="(item, index) in checkout?.reservation?.payment"
                      :key="index"
                    >
                      <!-- {{ item.payment_type }} 
                            (Date: {{ item.payment_date }}, {{ formatIDR(item.amount ?? 0) }}) -->

                      {{ item.payment_type }}
                      ({{ formatIDR(item.amount ?? 0) }} at
                      {{ getFormattedDate(item.payment_date) }})
                    </div>
                  </td>
                </tr>

                <tr class="border-b border-transparent">
                  <td class="text-left">Pending Bill</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{
                      formatIDR(checkout?.reservation?.outstanding_balance ?? 0)
                    }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Total</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ formatIDR(checkout?.reservation?.total_paid ?? 0) }}
                  </td>
                </tr>
                <tr class="border-b border-transparent">
                  <td class="text-left">Status</td>
                  <td class="text-left">:</td>
                  <td class="text-left fw-semibold">
                    {{ checkout?.reservation?.payment_status ?? "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </CheckOutConfirm>

    <CheckOutDataTable
      :data="checkouts"
      :header="headers"
      :currentPage="currentPage"
      :custom-actions="customActions"
    />

    <!-- <DataPriview
      id="guestInfoModal"
      :selectedGuest="selectedGuest"
      :reservationDetails="reservationDetails"
      :extraCharges="extraCharges"
    /> -->

    <CheckOutFilter
      :modalFilter="modalFilter"
      @update:modalFilter="modalFilter = $event"
    />

    <ToastResponse
      v-model="toastResponse.toast"
      :text="toastResponse.text"
      :success="toastResponse.success"
    />
  </div>
</template>

<script>
import { ref, inject, onMounted, watch, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckOutForm from "./CheckoutForm.vue";
import CheckOutFilter from "./CheckoutFilter.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import CheckOutConfirm from "@/components/ModalDialog.vue";
import CheckOutStatistics from "@/components/StatisticData.vue";
import CheckOutDataTable from "@/components/DataTable.vue";
import iconWill from "../../../public/icons/visit.svg";
import iconPremature from "../../../public/icons/master-plan.svg";
import iconLate from "../../../public/icons/overview.svg";
import iconCheckOut from "../../../public/icons/door-open.svg";
// import DataPriview from "@/components/DataPriview.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import CheckoutDetail from "./CheckoutDetail.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";
import logo from "../../../public/img/hotel-deliriver.png";

export default {
  components: {
    HeaderContent,
    ActionContent,
    CheckOutForm,
    CheckOutConfirm,
    CheckOutFilter,
    CheckOutStatistics,
    CheckOutDataTable,
    ModalConfirm,
    // DataPriview,
    PaymentForm,
    CheckoutDetail,
    ToastResponse,
  },
  setup() {
    const repositories = inject("repositories");
    const checkinRepository = repositories ? repositories.checkin : null;
    const modal = ref(false);
    const modalPayment = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalCheckOut = ref(false);
    const modalDetail = ref(false);
    const modalUuid = ref("");
    const selectedGuest = ref(null);
    const reservationDetails = ref(null);
    const extraCharges = ref([]);
    const isLoading = ref(false);
    const currentPage = ref(1);

    const reservationUuid = ref(null);
    const actionType = ref("checkout");
    const checkouts = ref([]);
    const checkout = ref({});

    const statistics = ref([]);

    const data = ref([]);
    const printLogo = ref(null);

    const toastResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "room_category",
        label: "Room Type",
        sortable: true,
      },
      {
        key: "reservation.room.code",
        label: "Room Number",
        sortable: true,
      },
      {
        key: "reservation.guest.fullname",
        label: "Guest Name",
        sortable: true,
      },
      {
        key: "status_reservation",
        label: "Status",
        sortable: true,
      },
      {
        key: "check_in_date",
        label: "Checkin",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "check_out_date",
        label: "Checkout",
        sortable: true,
        formatter: (value) => getFormattedDate(value),
      },
      {
        key: "days_left_calculated",
        label: "Day Left",
        sortable: true,
        formatter: (value, key, item) => {
          return daysLeft(item.check_out_date);
        },
      },
      {
        key: "reservation.outstanding_balance",
        label: "Remaining Bill",
        sortable: true,
        formatter: (value) => formatIDR(value),
      },
      {
        key: "action",
        label: "Action",
      },
    ]);

    const customActions = ref([
      {
        label: "Bill Info",
        variant: "success",
        icon: "fas fa-file-alt",
        action: async (item) => {
          console.log(item);

          checkout.value = item;
          showDetailModal(item);
        },
      },
      {
        label: "Payment",
        variant: "primary",
        icon: "fas fa-money-bill-wave-alt",
        disabled: (item) =>
          item.reservation.is_paid ||
          item.reservation.payment_status === "Full Payment",
        action: (item) => {
          reservationUuid.value = item.reservation_uuid;
          modalPayment.value = true;
        },
      },
      {
        label: "Checkout",
        variant: "danger",
        icon: "fas fa-calendar-times",
        disabled: (item) =>
          !item.reservation.is_paid ||
          item.reservation.payment_status === "DP" ||
          item.reservation.status === "Check Out", //||
          //item.check_out_date !== formatDate(new Date()),
        action: (item) => {
          checkout.value = item;
          showConfirmModal(item);
        },
      },
    ]);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    // const startDate = ref(getStartDate);
    // const endDate = ref(getCurrentDate);

    const startDate = ref(formatDate(date));
    const endDate = ref(formatDate(date));
    const search = ref("");
    const filterStatus = ref({
      status: null,
    });

    function formatDate(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    }

    // function for days left
    const daysLeft = (checkOutDate) => {
      if (!checkOutDate) return "-";
      const today = new Date();
      const checkOut = new Date(checkOutDate);

      // reset time
      today.setHours(0, 0, 0, 0);
      checkOut.setHours(0, 0, 0, 0);
      const diffTime = checkOut.getTime() - today.getTime();
      // convert to 1 day
      const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const daysLeft = days < 0 ? 0 : days;
      return daysLeft;
    };

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = ""
    ) => {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.status = status;
      if (searchQuery) params.search = searchQuery;

      const res = await checkinRepository.getListCheckout(params);

      checkouts.value = res.data.data;
      const checkoutStatistics = res.data.statistics;

      statistics.value = [
        {
          label: "Total",
          key: "Will Check-Out",
          value: checkoutStatistics?.will_checkout,
          color: "warning",
          icon: iconWill,
        },
        {
          label: "Total",
          key: "Early Check-Out",
          value: checkoutStatistics?.early_checkout,
          color: "warning",
          icon: iconPremature,
        },
        {
          label: "Total",
          key: "Late Check-Out",
          value: checkoutStatistics?.late_checkout,
          color: "danger",
          icon: iconLate,
        },
        {
          label: "Total",
          key: "Check-Out",
          value: checkoutStatistics.checkout,
          color: "warning",
          icon: iconCheckOut,
        },
      ];
    };

    const showConfirmModal = (data) => {
      modalCheckOut.value = true;
      reservationUuid.value = data.reservation.uuid;
    };

    const showDetailModal = (data) => {
      modalDetail.value = true;
      reservationUuid.value = data.reservation.uuid;
      console.log("data reservasi", reservationUuid.value);
    };

    const handleAction = (actionType) => {
      if (actionType.type === "checkout") {
        setCheckout();
      }
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    const handleSearch = (query) => {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    };

    watch([startDate, endDate, filterStatus], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });

    const setCheckout = async () => {
      try {
        await checkinRepository
          .checkOut(reservationUuid.value, checkout.value)
          .then(() => {
            getAll();
            handlePrint();
            modalCheckOut.value = false;

            toastResponse.value = {
              toast: true,
              success: true,
              text:
                checkout.value.response?.message ||
                "Guest checked out successfully",
            };
          });
      } catch (e) {
        toastResponse.value = {
          toast: true,
          success: false,
          text: e.response?.data?.error || "Something went wrong!",
        };
        console.log(e);
      }
    };

    function handlePrint() {
      nextTick(() => {
        const printContents = document.getElementById("printArea").innerHTML;
        //const printWindow = window.open("", "", "width=80,height=auto");

        const now = new Date();
        const pad = (num) => String(num).padStart(2, "0");
        const formattedDate = `${now.getFullYear()}-${pad(
          now.getMonth() + 1
        )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
          now.getMinutes()
        )}-${pad(now.getSeconds())}`;
        const filename = `RECEIPT-deli-river-hotel-${formattedDate}`;

        // Penambahan buat iframe tersembunyi
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts"
        );
        document.body.appendChild(iframe);

        const doc = iframe.contentDocument || iframe.contentWindow.document;

        // const htmlTemplate = `
        //   <!DOCTYPE html>
        //   <html>
        //     <head>
        //       <title>${filename}</title>
        //       <style>
        //         @page {
        //           size: 80mm auto;
        //           margin: 5mm;
        //         }
        //         body {
        //           font-family: sans-serif;
        //           padding: 5px;
        //         }
        //         h2 {
        //           margin-bottom: 5px;
        //         }
        //         p {
        //           margin: 0 0 5px;
        //         }
        //       </style>
        //     </head>
        //     <body>
        //       ${printContents}
        //     </body>
        //   </html>
        // `;

        // printWindow.document.write(htmlTemplate);
        // printWindow.document.close();
        // printWindow.focus();

        // setTimeout(() => {
        //   printWindow.print();
        //   printWindow.close();
        // }, 100);
        
        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${filename}</title>
              <meta name="viewport" content="width=device-width,initial-scale=1.0">
              <style>
              @media print {
                
                @page {
                  size: 80mm auto;    
                }
                body {
                  font-family: "Consolas", monospace;
                  font-weight: bold;
                  font-size: 14px;
                  margin: 10px;
                  padding: 0;
                }
                h2 {
                  font-size: 10px;
                  margin: 0;
                }
                h3 {
                  margin: 0;
                }
                h4 {
                  margin: 0;
                }
                p {
                  margin: 3px 0px;
                }
                .billing-detail {
                  margin-top: -5px;
                }
                hr {
                  margin-top: -5px;
                }
                tbody {
                  margin: 0px;
                }
            }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        doc.close();

        // Tunggu iframe selesai load sebelum print
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          // Bersihkan iframe setelah print
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        };
        
      });
    }

    onMounted(() => {
      getAll();
    });

    return {
      data,
      headers,
      modal,
      modalPayment,
      checkout,
      checkouts,
      modalConfirm,
      modalCheckOut,
      modalFilter,
      actionType,
      handleAction,
      handleFilter,
      handleSearch,
      startDate,
      endDate,
      getStartDate,
      getCurrentDate,
      search,
      filterStatus,
      formatIDR,
      dateFormatter,
      countDays,
      getFormattedDate,
      customActions,
      statistics,
      checkinRepository,
      getAll,
      setCheckout,
      modalUuid,
      reservationUuid,
      selectedGuest,
      reservationDetails,
      extraCharges,
      isLoading,
      currentPage,
      modalDetail,
      toastResponse,
      logo,
      printLogo,
    };
  },
};
</script>
<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.payments {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.payment-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #00f974;
}

/* style untuk print */
@media print {
  body * {
    visibility: hidden;
  }
  #printArea,
  #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  #printArea .situs {
    padding: 30px;
  }
  button {
    display: none !important;
  }

  .navbar,
  .footer,
  .btn {
    display: none;
  }
  .print-only {
    display: block !important;
  }
  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}
.screen-only {
  display: block;
}
.situs {
  padding: 20px;
  margin: 20px;
  color: red;
}
</style>
